import { facebookPage } from 'ducks/entities/schema'

export const fetchPagesSchema = {
  facebookPages: [facebookPage],
}

export const bulkUpdatePagesSchema = {
  updateFacebookPageSubscriptions: [facebookPage],
}
